import { Navigate } from 'react-router'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'

import SectionCard from '@/containers/DevToolsNew/shared/SectionCard'
import { Stack } from '@/containers/DevToolsNew/CommunicationBoard/styled-components'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

import BetaFeatureCard from './BetaFeatureCard'
import useBetaFeatures from './useBetaFeatures'
import { MutedText, Title } from './styled-components'

const BetaFeaturesPage = () => {
  const {
    t,
    isAllowed,
    isLoading,
    error,
    features,
    isEmpty,
    isRemovalOpen,
    removalText,
    onCancelRemoval,
    onConfirmRemoval,
  } = useBetaFeatures()

  if (!isAllowed) {
    return <Navigate to='/dev-tools-v2/contacts' replace />
  }

  return (
    <Stack>
      <SectionCard>
        <Title>{t('beta_features.title')}</Title>
        <MutedText>{t('beta_features.intro')}</MutedText>
      </SectionCard>
      <SDNotification type='negative' hidden={!error} primaryText={t('beta_features.load_error')} />
      <SDLoader hidden={!isLoading} text={t('beta_features.loading')} />
      <MutedText hidden={!isEmpty}>{t('beta_features.no_features')}</MutedText>
      {features.map(betaFeature => (
        <BetaFeatureCard key={betaFeature.feature} betaFeature={betaFeature} />
      ))}
      <Modal onClose={onCancelRemoval} isOpen={isRemovalOpen} closeable={false}>
        <ModalHeader>{t('beta_features.remove_title')}</ModalHeader>
        <ModalBody>{removalText}</ModalBody>
        <ModalFooter>
          <ModalButton kind='tertiary' onClick={onCancelRemoval}>
            {t('beta_features.cancel')}
          </ModalButton>
          <ModalButton onClick={onConfirmRemoval}>{t('beta_features.remove')}</ModalButton>
        </ModalFooter>
      </Modal>
    </Stack>
  )
}

export default BetaFeaturesPage
